<div id="representative-table">
  <app-ep-table [config]="config" [data]="representatives$ | async" data-cy="representatives-table"></app-ep-table>
</div>
